import React from "react";

interface StickyHeaderProps {
  title: string;
  children?: React.ReactNode;
}

const StickyHeader: React.FC<StickyHeaderProps> = ({ title, children }) => {
  return (
    <div className="sticky top-0 z-20 bg-white border-b border-gray-200 py-4 px-6 flex items-center justify-between shadow-sm w-full">
      <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
      {children && <div className="flex items-center gap-4">{children}</div>}
    </div>
  );
};

export default StickyHeader;
